import { h, Host } from "@stencil/core";
export class GalleryModal {
    onKeyDown(event) {
        if (event.key.toLowerCase() === 'escape') {
            this.close();
        }
    }
    close() {
        this.el.remove();
    }
    render() {
        return h(Host, { key: '5c81904ac2a3f5fedd8659558cc7327e9601fbf0', class: "modal modal-gallery", style: { display: 'block' } }, h("a", { key: 'ba1ed71ff0945d644170f9b2305b00a95315f636', class: "modal-close", onClick: () => this.close(), "ga-click": true, "ga-category": "product", "ga-action": "image", "ga-label": "close" }, h("svg", { key: 'a52dbbde547b4749834f2c7670e2fb2e6287d086', width: 24, height: 24 }, h("use", { key: '36c7611422d7a2679a94d93e753908b65bf8148d', href: "#fa-close" }))), h("div", { key: '39d96838272167a3f1e099d09f68f39b0edc32a9', class: "modal-content" }, this.content, h("slot", { key: '7cb592d72d8f9474916539cf31d6541e26826a6a' })));
    }
    static get is() { return "uvex-gallery-modal"; }
    static get originalStyleUrls() {
        return {
            "$": ["./gallery-modal.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["gallery-modal.css"]
        };
    }
    static get properties() {
        return {
            "content": {
                "type": "any",
                "attribute": "content",
                "mutable": false,
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "reflect": false
            }
        };
    }
    static get elementRef() { return "el"; }
    static get listeners() {
        return [{
                "name": "keydown",
                "method": "onKeyDown",
                "target": "window",
                "capture": false,
                "passive": true
            }];
    }
}
//# sourceMappingURL=gallery-modal.js.map
